import script from "./ProductSearchBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSearchBox.vue?vue&type=script&setup=true&lang=js"

import "./ProductSearchBox.vue?vue&type=style&index=0&id=2dd9f922&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dd9f922"]])

export default __exports__